import { useMemo } from "react";
import { useGetList } from "ra-core";

export type Offer = {
  id: number;
  slug: string;
  name: string;
  priority: number;
  stages: string[];
  won_stage: string;
  lost_stage: string;
  active: boolean;
  key: string | null;
  color: string | null;
};

// Los 7 productos base: el directorio está segmentado por ellos (solo se archivan)
export const BASE_OFFERS = [
  "storcky",
  "mooi",
  "kelmo",
  "telemetria",
  "legal",
  "landing",
  "norvia",
];

/** Ofertas activas ordenadas por prioridad (1 = principal). */
// Orden estable: prioridad y luego id (varias comparten prioridad 1)
const byPriority = (a: Offer, b: Offer) =>
  a.priority - b.priority || a.id - b.id;

export const useOffers = () => {
  const result = useGetList<Offer>(
    "offers",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "priority", order: "ASC" },
      filter: { active: true },
    },
    { staleTime: 5 * 60 * 1000 },
  );
  // misma referencia entre renders: si no, los efectos que dependen de ella se reinician
  const data = useMemo(
    () => result.data && [...result.data].sort(byPriority),
    [result.data],
  );
  return { ...result, data };
};

// Color por producto (del prototipo). En el Bloque B pasa a offers.color.
const OFFER_COLORS: Record<string, string> = {
  storcky: "#4C8DF6",
  mooi: "#F59E42",
  kelmo: "#1FAF6B",
  telemetria: "#9B5DE5",
  legal: "#E5484D",
  landing: "#E9C03B",
  norvia: "#8A93A6",
};

export const offerColor = (o?: { slug?: string; color?: string | null }) =>
  o?.color ?? OFFER_COLORS[o?.slug ?? ""] ?? "#8A93A6";

/** Todas las ofertas, también las archivadas (para ajustes y formularios). */
export const useAllOffers = () => {
  const result = useGetList<Offer>("offers", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "priority", order: "ASC" },
  });
  // misma referencia entre renders: si no, los efectos que dependen de ella se reinician
  const data = useMemo(
    () => result.data && [...result.data].sort(byPriority),
    [result.data],
  );
  return { ...result, data };
};
